<template>
  <div class="achievement">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',

}

</script>

<style lang="scss" scoped>
.achievement {
  height: calc(100% - 50px);
  padding: 10px;
  // background-color: #eee;
  margin-top: 10px;
  box-shadow:#eee 0px 0px 10px
}
</style>
